// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:400,700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .popup-content {
    background: #fff;
    padding: 40px;
    border-radius: 8px;
    position: relative;
    width: 50%; /* Adjust width as needed */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 20px;
  }

  .popup-content h2 {
    font-size: 1.75em; /* Larger font size for the title */
    font-weight: bold;
    margin-bottom: 10px; /* Spacing below the title */
  }
  
  .popup-content p {
    font-size: 1.5em; /* Larger font size for the question */
    font-weight: bold;
    margin-bottom: 5px; /* Spacing below the question */
  }
  
  .close-button {
    position: absolute;
    top: 10px;
    right: 15px;
    border: none;
    background: none;
    font-size: 2em;
    cursor: pointer;
  }

  .question-inbetween {
    margin-top: 1rem; /* Adjust the space above */
    margin-bottom: 1rem; /* Adjust the space below */
  }
  
  .form-group {
    margin-bottom: 15px; /* Increased spacing between answer options */
    display: flex; /* Use flexbox for alignment */
    align-items: center; /* Align items vertically */
  }
  
  .form-group {
    margin-bottom: 20px;
  }
  
  .form-group label {
    font-size: 1em; /* Legible font size for answers */
  }
  
  .form-group input[type="radio"] {
    margin-right: 10px; /* Space between radio button and label */
    /* Custom radio button styles can be applied here */
  }

  .button-container {
    display: flex; /* Use flexbox to lay out buttons next to each other */
    justify-content: flex-start; /* Align buttons to the left */
    gap: 10px; /* Add space between buttons */
    margin-top: 20px; /* Space above the button container */
  }
  
  .save-button,
  .cancel-button {
    font-weight: bold;
    padding: 10px 20px;
    font-size: 1em;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    /* Removed flex: 1; to not force buttons to grow */
    transition: background-color 0.3s ease;
  }
  
  /* Adjust the width of the buttons to match the desired size */
  .save-button {
    background-color: #008ac9; /* Blue, like the "Weiter" button */
    color: white;
    width: auto; /* Adjust if you have a specific width in mind */
    padding: 10px 24px; /* Adjust padding to control the size */
  }
  
  .save-button:hover {
    background-color: #006391; /* Darker blue on hover */
  }
  
  .cancel-button {
    background-color: #6c757d; /* Grey, like typical cancel buttons */
    color: white;
    width: auto; /* Adjust if you have a specific width in mind */
    padding: 10px 24px; /* Adjust padding to control the size */
  }
  
  .cancel-button:hover {
    background-color: #565e64; /* Darker grey on hover */
  }
  

  @media (max-width: 600px) {
    .popup-content h2, .popup-content p {
      font-size: 1.25em; /* Smaller font size on mobile */
    }
  }
  
  /*NodeLabel.css*/
  /******************************************************************************/
  
  .treeWrapper {
    display: block;
    height: 100%;
    width: 100%;
    overflow: hidden;
  }

  .skill-tree {
    overflow: hidden; /* or 'scroll' to always show scrollbars */
    height: 100%; /* Adjust the height as necessary */
    width: 100%; /* Adjust the width as necessary */
  }
  
  .linkBase {
    stroke: #A5A5D7 !important;
    stroke-width: 3px;
    stroke-linejoin: round;
    border-style: double;
  }
  
  .child-node{
    position: relative;
    top: 46%;
    left: 51%;
    transform: translate(-50%, -50%);
    width: 300px;
    height: 70px;
    background-color: red;
    border-radius: 20px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    padding: 20px;
    box-sizing: border-box;
  }
  
  .node-layout5 {
    position: absolute;
    display: flex;
    height: fit-content;
    flex-direction: column;
    justify-content: center;
    width: fit-content;
    align-items: center;
    background-color: white;
    border-radius: 20px;
    padding: 10px;
    box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.1), 0px 0px 10px rgba(0, 0, 0, 0.2);
    border: solid 1px #BCCED9;
    margin: 5px;
  }
  
  .node-complete {
    box-shadow: 0 26.6px 25.48px rgba(3, 137, 32, 0.09),
                0 13.8px 13px rgba(3, 137, 32, 0.07),
                0 5.6px 6.52px rgba(3, 137, 32, 0.05),
                0 1.3px 3.15px rgba(3, 137, 32, 0.03);
    border: solid 2px #53CA43;
  }
  
  .node-incomplete {
    box-shadow: 0 26.6px 25.48px rgba(255, 56, 56, 0.07),
                0 13.8px 13px rgba(255, 56, 56, 0.05),
                0 1.3px 3.15px rgba(255, 56, 56, 0.04);
    border: solid 2px #FF2D2E;
  }
  
  .title5 {
    display: flex;
    width: fit-content;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    
  }
  
  .befragung {
    color: #383874;
    font-family: 'Open Sans', sans-serif;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    display: inline-block;
    width: 164px;
  }
  
  .dimension{  
    position: relative;
    font-size: var(--mini-button-label-size);
    font-family: 'Open Sans', sans-serif;
    letter-spacing: 0.44px;
    line-height: 20px;
    font-family: var(--tips-and-details-overline);
    display: inline-block;
    width: fit-content;
    margin-right: auto;
  }
  
  .frage {
    color: #383874;
    font-family: 'Roboto', sans-serif;
    font-weight: normal;
    font-size: 14px;
    letter-spacing: 0.44px;
    line-height: 20px;
    display: inline-block;
    width: 164px;
  }
  
  
  /* Your existing styles.css content, with additional styles for the custom root node overlay */
  .custom-root-node-overlay {
    position: absolute;
    top: 1%;
    left: 0%;
    background-color: white; /* Originally white background, now red */
    border-radius: 20px; /* Rounded corners */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Shadow for depth */
    display: flex; /* Using flex layout */
    flex-direction: column; /* Elements inside are stacked vertically */
    align-items: center; /* Centered horizontally */
    justify-content: space-around; /* Space distributed evenly */
    padding: 20px; /* Padding around the content */
    box-sizing: border-box; /* Includes padding and border in the element's total width and height */
    z-index: 2; /* Stack order */
    width: 220px; /* Width of the node */
    height: 270px; /* Height based on content */
    cursor: pointer; /* Change cursor to indicate it's clickable */
    /* Additional styles like margin, color, etc., can be added as needed */
    border: 1px solid #C7C7E8;

    /* TEXT FONT */
    font-family: Open Sans;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
  }  
  
  .node {
    position: absolute;
    top: 10px;
    left: 0;
    width: 226px;
    height: 263px;
    border: red 1px solid;
  }
  
  
  .title-layout {
    position: absolute;
    height: 100%;
    top: 0;
    bottom: 0;
    left: calc(50% - 113px);
    border-radius: var(--br-base);
    
    box-shadow: #C7C7E8;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 24px 24px;
  }
  
  
  
  .more-horizontal-mini {
    position: relative;
    width: 18px;
    height: 18px;
    overflow: hidden;
    flex-shrink: 0;
  }
  
  .informers4 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    position: absolute;
    top: 98px;
    left: 24px;
    gap: var(--gap-xl);
    font-family: 'Poppins', sans-serif;
    
  }
  
  .projected-income {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
  
  .title6 {
    align-self: stretch;
    position: relative;
    letter-spacing: 0.44px;
    line-height: 24px;
    font-weight: 300;
    font-family: 'Poppins', sans-serif;
    color: #383874
  }
  
  .value19 {
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 0px;
    font-size: 14px;
    font-weight: 300;
  }
  
  .value20 {
    position: relative;
    line-height: 36px;
    font-weight: 600;
    color: #383874;
    font-size: 22px;
    padding: 0px px;
  }
  
  .chart1 {
    position: absolute;
    width: 129px;
    height: 27px;
    font-size: var(--footnote-size);
    color: #5a5a89;
    font-family: var(--button-label);
    left: 60px;
  }
  
  .indicator {
    position: absolute;
    top: 0;
    left: 80.62%;
    letter-spacing: 0.44px;
    line-height: 20px;
  }
  
  .chart2 {
    position: absolute;
    bottom: 0;
    left: 60px;
    height: 22.22%;
    width: 82%;
    top: 77.78%;
    right: 0;
  }
  
  .background {
    position: absolute;
    height: 16.67%;
    width: 100%;
    top: 41.67%;
    right: 0;
    bottom: 41.67%;
    left: 0;
    border-radius: var(--br-81xl);
    background-color: #E2E2EA;
  }
  
  .progress {
    position: absolute;
    height: 16.67%;
    width: 100%;
    top: 41.67%;
    right: 0;
    bottom: 41.67%;
    left: 0;
    border-radius: var(--br-81xl);
    background-color: #8676FF;
  }
  
  .title7 {
    position: relative;
    letter-spacing: 0.44px;
    line-height: 24px;
    font-weight: 300;
    font-family: 'Poppins', sans-serif;
    color: #383874
  }
  

  
  .background1 {
    position: absolute;
    height: 16.67%;
    width: 100%;
    top: 41.67%;
    right: 0;
    bottom: 41.67%;
    left: 0;
    border-radius: var(--br-81xl);
    background-color: #8676FF;
  }
  
  .progress1 {
    position: absolute;
    height: 16.67%;
    width: 100%;
    top: 41.67%;
    right: 0;
    bottom: 41.67%;
    left: 0;
    border-radius: var(--br-81xl);
    background-color: #FF708B;
  }
  
  .chart-1,
  .chart-2 {
    position: absolute;
    border-radius: var(--br-6xs-5);
    background-color: #FF708B;
    width: 60px;
    height: 6px;
  }
  .chart-2 {
    background-color: #8676FF;
    width: 26px;
  }
  
  .divider2 {
    position: absolute;
    top: 87px;
    left: 24px;
    background-color: rgba(106, 106, 159, 0.2);
    width: 178px;
    height: 1px;
  }
  
  .value19 {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }
  
  .value20 {
    flex: none; /* Prevent the number from growing */
    margin-right: 10px; /* Adjust space between the number and the bar */
    
  }
  
  .chart1 {
    flex-grow: 1; /* Allow the bar to fill the space */
    max-width: 100px; /* Shorten the bar */
  }
  
  .indicator {
    position: absolute;
    font-size: 14px;
    left: 120%; /* Adjust the position to be to the right of the bar */
  }



.root-container {
  position: relative;
  height: 98%;
  border-radius: 16px;
  border: 2px solid var(--border);  
  background: var(--white-base);
  padding-left: 20px;
  padding-right: 20px;


  /* TEXT FONT */
  font-family: Open Sans;
  font-style: normal;

}

.root-title {
  position: relative;
  margin: 10px 0px;
  /* TEXT FONT */
  font-size: 16px;
  font-weight: 700;
  line-height: 24px; 
}

.root-undertitle {
  position: relative;
  /* TEXT FONT */
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.44px;
}

.root-divider {
  position: relative;
  height: 1px;
  flex-shrink: 0;
  margin: 10px 0px;
  background-color: var(--gray-20);
}

.root-root-content {
  position: relative;
}

.root-element-title {
  /* TEXT FONT */
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 24px; /* 150% */
  letter-spacing: 0.44px;
}

.root-element-content {
  position: relative;
  display: flex;
}

.root-element-number {
  /* TEXT FONT */
  font-size: 18px;
  font-weight: 600;
  line-height: 36px;
}

.root-element-progressbar {
  position: relative;
  width: 100%;
  margin: 0px 10px;
}

.root-element-progress-number {
  position: relative;
  text-align: right;
}

.root-element-progressbar-container {
  position: relative;
  height: 5px;
  border-radius: 5px;
  background-color: var(--white-theme-gray-3);
}

.root-element-progressbar-complete {
  position: relative;
  height: 5px;
  width: 20%;
  border-radius: 5px;
  background-color: var(--primary-600);
}


.fragen-close{
  width: 40px;
  margin-right: 20px;
  margin-left: auto;
  margin-top: 20px;
}

`, "",{"version":3,"sources":["webpack://./src/widgets/BewertungFrageboegenWidgets.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,UAAU,EAAE,2BAA2B;IACvC,wCAAwC;IACxC,aAAa;EACf;;EAEA;IACE,iBAAiB,EAAE,mCAAmC;IACtD,iBAAiB;IACjB,mBAAmB,EAAE,4BAA4B;EACnD;;EAEA;IACE,gBAAgB,EAAE,sCAAsC;IACxD,iBAAiB;IACjB,kBAAkB,EAAE,+BAA+B;EACrD;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,gBAAgB,EAAE,2BAA2B;IAC7C,mBAAmB,EAAE,2BAA2B;EAClD;;EAEA;IACE,mBAAmB,EAAE,6CAA6C;IAClE,aAAa,EAAE,8BAA8B;IAC7C,mBAAmB,EAAE,2BAA2B;EAClD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc,EAAE,kCAAkC;EACpD;;EAEA;IACE,kBAAkB,EAAE,yCAAyC;IAC7D,mDAAmD;EACrD;;EAEA;IACE,aAAa,EAAE,sDAAsD;IACrE,2BAA2B,EAAE,8BAA8B;IAC3D,SAAS,EAAE,8BAA8B;IACzC,gBAAgB,EAAE,qCAAqC;EACzD;;EAEA;;IAEE,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kDAAkD;IAClD,sCAAsC;EACxC;;EAEA,8DAA8D;EAC9D;IACE,yBAAyB,EAAE,mCAAmC;IAC9D,YAAY;IACZ,WAAW,EAAE,gDAAgD;IAC7D,kBAAkB,EAAE,uCAAuC;EAC7D;;EAEA;IACE,yBAAyB,EAAE,yBAAyB;EACtD;;EAEA;IACE,yBAAyB,EAAE,sCAAsC;IACjE,YAAY;IACZ,WAAW,EAAE,gDAAgD;IAC7D,kBAAkB,EAAE,uCAAuC;EAC7D;;EAEA;IACE,yBAAyB,EAAE,yBAAyB;EACtD;;;EAGA;IACE;MACE,iBAAiB,EAAE,gCAAgC;IACrD;EACF;;EAEA,gBAAgB;EAChB,+EAA+E;;EAK/E;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,gBAAgB,EAAE,0CAA0C;IAC5D,YAAY,EAAE,mCAAmC;IACjD,WAAW,EAAE,kCAAkC;EACjD;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,YAAY;IACZ,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;IACnB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,6EAA6E;IAC7E,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE;;;qDAGiD;IACjD,yBAAyB;EAC3B;;EAEA;IACE;;sDAEkD;IAClD,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;;EAEzB;;EAEA;IACE,cAAc;IACd,oCAAoC;IACpC,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,wCAAwC;IACxC,oCAAoC;IACpC,sBAAsB;IACtB,iBAAiB;IACjB,6CAA6C;IAC7C,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,iCAAiC;IACjC,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;EACd;;;EAGA,8FAA8F;EAC9F;IACE,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,uBAAuB,EAAE,yCAAyC;IAClE,mBAAmB,EAAE,oBAAoB;IACzC,wCAAwC,EAAE,qBAAqB;IAC/D,aAAa,EAAE,sBAAsB;IACrC,sBAAsB,EAAE,2CAA2C;IACnE,mBAAmB,EAAE,0BAA0B;IAC/C,6BAA6B,EAAE,6BAA6B;IAC5D,aAAa,EAAE,+BAA+B;IAC9C,sBAAsB,EAAE,wEAAwE;IAChG,UAAU,EAAE,gBAAgB;IAC5B,YAAY,EAAE,sBAAsB;IACpC,aAAa,EAAE,4BAA4B;IAC3C,eAAe,EAAE,6CAA6C;IAC9D,uEAAuE;IACvE,yBAAyB;;IAEzB,cAAc;IACd,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,YAAY;IACZ,aAAa;IACb,qBAAqB;EACvB;;;EAGA;IACE,kBAAkB;IAClB,YAAY;IACZ,MAAM;IACN,SAAS;IACT,uBAAuB;IACvB,6BAA6B;;IAE7B,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,kBAAkB;EACpB;;;;EAIA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,kCAAkC;;EAEpC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC;EACF;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,QAAQ;IACR,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,+BAA+B;IAC/B,cAAc;IACd,gCAAgC;IAChC,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,cAAc;IACd,UAAU;IACV,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,WAAW;IACX,QAAQ;IACR,cAAc;IACd,OAAO;IACP,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,WAAW;IACX,QAAQ;IACR,cAAc;IACd,OAAO;IACP,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC;EACF;;;;EAIA;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,WAAW;IACX,QAAQ;IACR,cAAc;IACd,OAAO;IACP,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,WAAW;IACX,QAAQ;IACR,cAAc;IACd,OAAO;IACP,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA;;IAEE,kBAAkB;IAClB,8BAA8B;IAC9B,yBAAyB;IACzB,WAAW;IACX,WAAW;EACb;EACA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,0CAA0C;IAC1C,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,UAAU,EAAE,oCAAoC;IAChD,kBAAkB,EAAE,gDAAgD;;EAEtE;;EAEA;IACE,YAAY,EAAE,oCAAoC;IAClD,gBAAgB,EAAE,oBAAoB;EACxC;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,UAAU,EAAE,sDAAsD;EACpE;;;;AAIF;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;;;EAGnB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;;AAEpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,oCAAoC;AACtC;;;AAGA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[".popup {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 1000;\r\n  }\r\n  \r\n  .popup-content {\r\n    background: #fff;\r\n    padding: 40px;\r\n    border-radius: 8px;\r\n    position: relative;\r\n    width: 50%; /* Adjust width as needed */\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n    padding: 20px;\r\n  }\r\n\r\n  .popup-content h2 {\r\n    font-size: 1.75em; /* Larger font size for the title */\r\n    font-weight: bold;\r\n    margin-bottom: 10px; /* Spacing below the title */\r\n  }\r\n  \r\n  .popup-content p {\r\n    font-size: 1.5em; /* Larger font size for the question */\r\n    font-weight: bold;\r\n    margin-bottom: 5px; /* Spacing below the question */\r\n  }\r\n  \r\n  .close-button {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 15px;\r\n    border: none;\r\n    background: none;\r\n    font-size: 2em;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .question-inbetween {\r\n    margin-top: 1rem; /* Adjust the space above */\r\n    margin-bottom: 1rem; /* Adjust the space below */\r\n  }\r\n  \r\n  .form-group {\r\n    margin-bottom: 15px; /* Increased spacing between answer options */\r\n    display: flex; /* Use flexbox for alignment */\r\n    align-items: center; /* Align items vertically */\r\n  }\r\n  \r\n  .form-group {\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .form-group label {\r\n    font-size: 1em; /* Legible font size for answers */\r\n  }\r\n  \r\n  .form-group input[type=\"radio\"] {\r\n    margin-right: 10px; /* Space between radio button and label */\r\n    /* Custom radio button styles can be applied here */\r\n  }\r\n\r\n  .button-container {\r\n    display: flex; /* Use flexbox to lay out buttons next to each other */\r\n    justify-content: flex-start; /* Align buttons to the left */\r\n    gap: 10px; /* Add space between buttons */\r\n    margin-top: 20px; /* Space above the button container */\r\n  }\r\n  \r\n  .save-button,\r\n  .cancel-button {\r\n    font-weight: bold;\r\n    padding: 10px 20px;\r\n    font-size: 1em;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    /* Removed flex: 1; to not force buttons to grow */\r\n    transition: background-color 0.3s ease;\r\n  }\r\n  \r\n  /* Adjust the width of the buttons to match the desired size */\r\n  .save-button {\r\n    background-color: #008ac9; /* Blue, like the \"Weiter\" button */\r\n    color: white;\r\n    width: auto; /* Adjust if you have a specific width in mind */\r\n    padding: 10px 24px; /* Adjust padding to control the size */\r\n  }\r\n  \r\n  .save-button:hover {\r\n    background-color: #006391; /* Darker blue on hover */\r\n  }\r\n  \r\n  .cancel-button {\r\n    background-color: #6c757d; /* Grey, like typical cancel buttons */\r\n    color: white;\r\n    width: auto; /* Adjust if you have a specific width in mind */\r\n    padding: 10px 24px; /* Adjust padding to control the size */\r\n  }\r\n  \r\n  .cancel-button:hover {\r\n    background-color: #565e64; /* Darker grey on hover */\r\n  }\r\n  \r\n\r\n  @media (max-width: 600px) {\r\n    .popup-content h2, .popup-content p {\r\n      font-size: 1.25em; /* Smaller font size on mobile */\r\n    }\r\n  }\r\n  \r\n  /*NodeLabel.css*/\r\n  /******************************************************************************/\r\n  @import url('https://fonts.googleapis.com/css?family=Open+Sans:400,700&display=swap');\r\n  @import url('https://fonts.googleapis.com/css?family=Roboto:400,700&display=swap');\r\n  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap');\r\n  \r\n  .treeWrapper {\r\n    display: block;\r\n    height: 100%;\r\n    width: 100%;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .skill-tree {\r\n    overflow: hidden; /* or 'scroll' to always show scrollbars */\r\n    height: 100%; /* Adjust the height as necessary */\r\n    width: 100%; /* Adjust the width as necessary */\r\n  }\r\n  \r\n  .linkBase {\r\n    stroke: #A5A5D7 !important;\r\n    stroke-width: 3px;\r\n    stroke-linejoin: round;\r\n    border-style: double;\r\n  }\r\n  \r\n  .child-node{\r\n    position: relative;\r\n    top: 46%;\r\n    left: 51%;\r\n    transform: translate(-50%, -50%);\r\n    width: 300px;\r\n    height: 70px;\r\n    background-color: red;\r\n    border-radius: 20px;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-around;\r\n    align-items: center;\r\n    padding: 20px;\r\n    box-sizing: border-box;\r\n  }\r\n  \r\n  .node-layout5 {\r\n    position: absolute;\r\n    display: flex;\r\n    height: fit-content;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    width: fit-content;\r\n    align-items: center;\r\n    background-color: white;\r\n    border-radius: 20px;\r\n    padding: 10px;\r\n    box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.1), 0px 0px 10px rgba(0, 0, 0, 0.2);\r\n    border: solid 1px #BCCED9;\r\n    margin: 5px;\r\n  }\r\n  \r\n  .node-complete {\r\n    box-shadow: 0 26.6px 25.48px rgba(3, 137, 32, 0.09),\r\n                0 13.8px 13px rgba(3, 137, 32, 0.07),\r\n                0 5.6px 6.52px rgba(3, 137, 32, 0.05),\r\n                0 1.3px 3.15px rgba(3, 137, 32, 0.03);\r\n    border: solid 2px #53CA43;\r\n  }\r\n  \r\n  .node-incomplete {\r\n    box-shadow: 0 26.6px 25.48px rgba(255, 56, 56, 0.07),\r\n                0 13.8px 13px rgba(255, 56, 56, 0.05),\r\n                0 1.3px 3.15px rgba(255, 56, 56, 0.04);\r\n    border: solid 2px #FF2D2E;\r\n  }\r\n  \r\n  .title5 {\r\n    display: flex;\r\n    width: fit-content;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    \r\n  }\r\n  \r\n  .befragung {\r\n    color: #383874;\r\n    font-family: 'Open Sans', sans-serif;\r\n    font-weight: bold;\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n    display: inline-block;\r\n    width: 164px;\r\n  }\r\n  \r\n  .dimension{  \r\n    position: relative;\r\n    font-size: var(--mini-button-label-size);\r\n    font-family: 'Open Sans', sans-serif;\r\n    letter-spacing: 0.44px;\r\n    line-height: 20px;\r\n    font-family: var(--tips-and-details-overline);\r\n    display: inline-block;\r\n    width: fit-content;\r\n    margin-right: auto;\r\n  }\r\n  \r\n  .frage {\r\n    color: #383874;\r\n    font-family: 'Roboto', sans-serif;\r\n    font-weight: normal;\r\n    font-size: 14px;\r\n    letter-spacing: 0.44px;\r\n    line-height: 20px;\r\n    display: inline-block;\r\n    width: 164px;\r\n  }\r\n  \r\n  \r\n  /* Your existing styles.css content, with additional styles for the custom root node overlay */\r\n  .custom-root-node-overlay {\r\n    position: absolute;\r\n    top: 1%;\r\n    left: 0%;\r\n    background-color: white; /* Originally white background, now red */\r\n    border-radius: 20px; /* Rounded corners */\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Shadow for depth */\r\n    display: flex; /* Using flex layout */\r\n    flex-direction: column; /* Elements inside are stacked vertically */\r\n    align-items: center; /* Centered horizontally */\r\n    justify-content: space-around; /* Space distributed evenly */\r\n    padding: 20px; /* Padding around the content */\r\n    box-sizing: border-box; /* Includes padding and border in the element's total width and height */\r\n    z-index: 2; /* Stack order */\r\n    width: 220px; /* Width of the node */\r\n    height: 270px; /* Height based on content */\r\n    cursor: pointer; /* Change cursor to indicate it's clickable */\r\n    /* Additional styles like margin, color, etc., can be added as needed */\r\n    border: 1px solid #C7C7E8;\r\n\r\n    /* TEXT FONT */\r\n    font-family: Open Sans;\r\n    font-size: 16px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    line-height: 24px;\r\n  }  \r\n  \r\n  .node {\r\n    position: absolute;\r\n    top: 10px;\r\n    left: 0;\r\n    width: 226px;\r\n    height: 263px;\r\n    border: red 1px solid;\r\n  }\r\n  \r\n  \r\n  .title-layout {\r\n    position: absolute;\r\n    height: 100%;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: calc(50% - 113px);\r\n    border-radius: var(--br-base);\r\n    \r\n    box-shadow: #C7C7E8;\r\n    box-sizing: border-box;\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: flex-start;\r\n    justify-content: flex-start;\r\n    padding: 24px 24px;\r\n  }\r\n  \r\n  \r\n  \r\n  .more-horizontal-mini {\r\n    position: relative;\r\n    width: 18px;\r\n    height: 18px;\r\n    overflow: hidden;\r\n    flex-shrink: 0;\r\n  }\r\n  \r\n  .informers4 {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    justify-content: flex-start;\r\n    position: absolute;\r\n    top: 98px;\r\n    left: 24px;\r\n    gap: var(--gap-xl);\r\n    font-family: 'Poppins', sans-serif;\r\n    \r\n  }\r\n  \r\n  .projected-income {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    justify-content: flex-start;\r\n  }\r\n  \r\n  .title6 {\r\n    align-self: stretch;\r\n    position: relative;\r\n    letter-spacing: 0.44px;\r\n    line-height: 24px;\r\n    font-weight: 300;\r\n    font-family: 'Poppins', sans-serif;\r\n    color: #383874\r\n  }\r\n  \r\n  .value19 {\r\n    overflow: hidden;\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: flex-start;\r\n    justify-content: flex-start;\r\n    gap: 0px;\r\n    font-size: 14px;\r\n    font-weight: 300;\r\n  }\r\n  \r\n  .value20 {\r\n    position: relative;\r\n    line-height: 36px;\r\n    font-weight: 600;\r\n    color: #383874;\r\n    font-size: 22px;\r\n    padding: 0px px;\r\n  }\r\n  \r\n  .chart1 {\r\n    position: absolute;\r\n    width: 129px;\r\n    height: 27px;\r\n    font-size: var(--footnote-size);\r\n    color: #5a5a89;\r\n    font-family: var(--button-label);\r\n    left: 60px;\r\n  }\r\n  \r\n  .indicator {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 80.62%;\r\n    letter-spacing: 0.44px;\r\n    line-height: 20px;\r\n  }\r\n  \r\n  .chart2 {\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 60px;\r\n    height: 22.22%;\r\n    width: 82%;\r\n    top: 77.78%;\r\n    right: 0;\r\n  }\r\n  \r\n  .background {\r\n    position: absolute;\r\n    height: 16.67%;\r\n    width: 100%;\r\n    top: 41.67%;\r\n    right: 0;\r\n    bottom: 41.67%;\r\n    left: 0;\r\n    border-radius: var(--br-81xl);\r\n    background-color: #E2E2EA;\r\n  }\r\n  \r\n  .progress {\r\n    position: absolute;\r\n    height: 16.67%;\r\n    width: 100%;\r\n    top: 41.67%;\r\n    right: 0;\r\n    bottom: 41.67%;\r\n    left: 0;\r\n    border-radius: var(--br-81xl);\r\n    background-color: #8676FF;\r\n  }\r\n  \r\n  .title7 {\r\n    position: relative;\r\n    letter-spacing: 0.44px;\r\n    line-height: 24px;\r\n    font-weight: 300;\r\n    font-family: 'Poppins', sans-serif;\r\n    color: #383874\r\n  }\r\n  \r\n\r\n  \r\n  .background1 {\r\n    position: absolute;\r\n    height: 16.67%;\r\n    width: 100%;\r\n    top: 41.67%;\r\n    right: 0;\r\n    bottom: 41.67%;\r\n    left: 0;\r\n    border-radius: var(--br-81xl);\r\n    background-color: #8676FF;\r\n  }\r\n  \r\n  .progress1 {\r\n    position: absolute;\r\n    height: 16.67%;\r\n    width: 100%;\r\n    top: 41.67%;\r\n    right: 0;\r\n    bottom: 41.67%;\r\n    left: 0;\r\n    border-radius: var(--br-81xl);\r\n    background-color: #FF708B;\r\n  }\r\n  \r\n  .chart-1,\r\n  .chart-2 {\r\n    position: absolute;\r\n    border-radius: var(--br-6xs-5);\r\n    background-color: #FF708B;\r\n    width: 60px;\r\n    height: 6px;\r\n  }\r\n  .chart-2 {\r\n    background-color: #8676FF;\r\n    width: 26px;\r\n  }\r\n  \r\n  .divider2 {\r\n    position: absolute;\r\n    top: 87px;\r\n    left: 24px;\r\n    background-color: rgba(106, 106, 159, 0.2);\r\n    width: 178px;\r\n    height: 1px;\r\n  }\r\n  \r\n  .value19 {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n  }\r\n  \r\n  .value20 {\r\n    flex: none; /* Prevent the number from growing */\r\n    margin-right: 10px; /* Adjust space between the number and the bar */\r\n    \r\n  }\r\n  \r\n  .chart1 {\r\n    flex-grow: 1; /* Allow the bar to fill the space */\r\n    max-width: 100px; /* Shorten the bar */\r\n  }\r\n  \r\n  .indicator {\r\n    position: absolute;\r\n    font-size: 14px;\r\n    left: 120%; /* Adjust the position to be to the right of the bar */\r\n  }\r\n\r\n\r\n\r\n.root-container {\r\n  position: relative;\r\n  height: 98%;\r\n  border-radius: 16px;\r\n  border: 2px solid var(--border);  \r\n  background: var(--white-base);\r\n  padding-left: 20px;\r\n  padding-right: 20px;\r\n\r\n\r\n  /* TEXT FONT */\r\n  font-family: Open Sans;\r\n  font-style: normal;\r\n\r\n}\r\n\r\n.root-title {\r\n  position: relative;\r\n  margin: 10px 0px;\r\n  /* TEXT FONT */\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  line-height: 24px; \r\n}\r\n\r\n.root-undertitle {\r\n  position: relative;\r\n  /* TEXT FONT */\r\n  font-family: Roboto;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  line-height: 20px;\r\n  letter-spacing: 0.44px;\r\n}\r\n\r\n.root-divider {\r\n  position: relative;\r\n  height: 1px;\r\n  flex-shrink: 0;\r\n  margin: 10px 0px;\r\n  background-color: var(--gray-20);\r\n}\r\n\r\n.root-root-content {\r\n  position: relative;\r\n}\r\n\r\n.root-element-title {\r\n  /* TEXT FONT */\r\n  font-family: Poppins;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 300;\r\n  line-height: 24px; /* 150% */\r\n  letter-spacing: 0.44px;\r\n}\r\n\r\n.root-element-content {\r\n  position: relative;\r\n  display: flex;\r\n}\r\n\r\n.root-element-number {\r\n  /* TEXT FONT */\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  line-height: 36px;\r\n}\r\n\r\n.root-element-progressbar {\r\n  position: relative;\r\n  width: 100%;\r\n  margin: 0px 10px;\r\n}\r\n\r\n.root-element-progress-number {\r\n  position: relative;\r\n  text-align: right;\r\n}\r\n\r\n.root-element-progressbar-container {\r\n  position: relative;\r\n  height: 5px;\r\n  border-radius: 5px;\r\n  background-color: var(--white-theme-gray-3);\r\n}\r\n\r\n.root-element-progressbar-complete {\r\n  position: relative;\r\n  height: 5px;\r\n  width: 20%;\r\n  border-radius: 5px;\r\n  background-color: var(--primary-600);\r\n}\r\n\r\n\r\n.fragen-close{\r\n  width: 40px;\r\n  margin-right: 20px;\r\n  margin-left: auto;\r\n  margin-top: 20px;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
